import { Papa } from 'ngx-papaparse';
import { utils, writeFileXLSX } from 'xlsx';

export class DashboardUtils {

  static csvBlobToxls = (
    papa: Papa,
    csvBlob: Blob,
    fileName: string,
  ) => new Promise<{blob: Blob, fileName: string}>( (resolve, reject) => {
    papa.parse(csvBlob, {
      header: true,
      skipEmptyLines: true,
      dynamicTyping: true,
      complete: (json) => {
        const ws = utils.json_to_sheet(json.data);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, fileName.slice(0,31));
        // convert to remove scientific notation
        Object.keys(ws).forEach(function(s) {
          if(ws[s].t === 'n') {
            ws[s].w = ws[s].v;
          }
        });
        // var wbout = write(wb, {type:"array", bookType:'xlsx'});
        // return resolve({blob: new Blob([wbout], {type: 'application/octet-stream'}), fileName});
        return writeFileXLSX(wb, fileName);
      },
    });
  });

  static filenameBuilder = (
    suffix: string,
    filters: {
      searchQuery?: string,
      eventId?: number,
      status?: string[],
      activeOnly?: boolean,
      purchaseAutoEnabled?: boolean,
      debitedWithoutTicketOnly?: boolean,
      categories?: number[],
      role?: string[],
      ticketingPlatform?: string[],
      payoutStatus?: string[],
      purchaseFlow?: string[],
      dateRangeStart?: string,
      dateRangeEnd?: string,
    },
  ) => {
    let fileName = suffix;
    if (filters.eventId) {
      fileName += `-event_${filters.eventId}`;
    }
    if (filters.status && filters.status.length > 0) {
      fileName += `-${filters.status.join('-')}`;
    }
    if (filters.activeOnly) {
      fileName += `-active`;
    }
    if (filters.purchaseAutoEnabled) {
      fileName += `-autopurchase`;
    }
    if (filters.debitedWithoutTicketOnly) {
      fileName += `-debitedwithoutticket`;
    }
    if (filters.role && filters.role.length > 0) {
      fileName += `-${filters.role.join('-')}`;
    }
    if (filters.ticketingPlatform && filters.ticketingPlatform.length > 0) {
      fileName += `-${filters.ticketingPlatform.join('-')}`;
    }
    if (filters.payoutStatus && filters.payoutStatus.length > 0) {
      fileName += `-${filters.payoutStatus.join('-')}`;
    }
    if (filters.purchaseFlow && filters.purchaseFlow.length > 0) {
      fileName += `-${filters.purchaseFlow.join('-')}`;
    }
    if (filters.dateRangeStart) {
      fileName += `-from_${filters.dateRangeStart}`;
    }
    if (filters.dateRangeEnd) {
      fileName += `-to_${filters.dateRangeEnd}`;
    }
    fileName += `-${DashboardUtils.getFormattedTime()}.csv`;
    return fileName;
  }

  static getFormattedTime = () => {
    const today = new Date();
    const y = today.getFullYear();
    // JavaScript months are 0-based.
    const m = today.getMonth() + 1;
    const d = today.getDate();
    const h = today.getHours();
    const mi = today.getMinutes();
    return y + '-' + m + '-' + d + '-' + h + '-' + mi;
  };

}
